import * as types from './mutation-types'
import Vue from 'vue'
import { IUmbTypeState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbUmbType, IAloDbUmbTypeConstParam } from '@/models/alodb/AloDbUmbType';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IUmbTypeState> = {
     
    //Gestion des recherches de missions
    [types.UMBTYPE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.UmbType.Title').toString()}).toString()
        state.umbTypeLoading = true
    },
    [types.UMBTYPE_SUCCESS]: (state, umbTypes:Array<AloDbUmbType>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.UmbType.Title').toString()}).toString()
        state.umbTypes = umbTypes   
        state.umbTypeLoading = false             
    },
    [types.UMBTYPE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.UmbType.Title').toString()}).toString()
        state.umbTypes = []
        state.umbTypeLoading = false
    },
    [types.UMBTYPE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.UmbType.Title').toString()} ${itemId}`}).toString()
        state.umbTypeLoading = true
    },
    [types.UMBTYPE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.UmbType.Title').toString()}).toString()
        state.umbTypeLoading = false
    },
    [types.UMBTYPE_SELECT_DETAIL_SUCCESS]: (state,umbType:AloDbUmbType) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.UmbType.Title').toString()} ${umbType.UMT_ID}`}).toString()        
        //1, on met à jour de m'umbType dans la liste des umbTypes
        const index = state.umbTypes.findIndex(m => m.UMT_ID == umbType.UMT_ID)
        state.umbTypes.splice(index == -1 ? state.umbTypes.length : index, index == -1 ? 0 : 1, umbType)
        state.umbTypeLoading = false
    },
    [types.UMBTYPE_SELECT_DETAIL]: (state,umbType:AloDbUmbType) => {                
        state.originalAdmUmbType = umbType
        state.modifiedAdmUmbType = new AloDbUmbType(umbType)
    },
    [types.UMBTYPE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.UmbType.Title').toString()} ${libelle}`}).toString()
        state.umbTypeLoading = true
    },
    [types.UMBTYPE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.UmbType.Title').toString()}).toString()
        state.umbTypeLoading = false
    },
    [types.UMBTYPE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmUmbType = {...state.modifiedAdmUmbType,...newProperties}
    },
    [types.UMBTYPE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    }           
}


export default mutations
